import { createContext } from 'react'
import initialState from './Popup.initialState'

const PopupContext = createContext(initialState)

export default PopupContext
